
      import Tool from './tool.vue'
      import type { App, Plugin } from 'vue'

      export const ToolPlugin: Plugin = {
        install(app: App) {
          app.component('Tool', Tool)
        },
      }
      export { Tool }
      